"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SelectFormFieldByConfig = void 0;
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _reactHookForm = require("react-hook-form");
var _constants = require("../../../constants");
var _utils = require("../../../utils");
var _jsxRuntime = require("react/jsx-runtime");
const SelectWrapper = (0, _mui.styled)('div')(() => ({
  display: 'flex',
  alignItems: 'center'
}));
const SelectFormFieldByConfig = props => {
  const {
    name,
    label,
    isEditable,
    isAvailable,
    displayOrder,
    options,
    validation,
    initialValue,
    isDisabled,
    labelMapper,
    ...selectField
  } = props;
  const {
    getTestId,
    getTestIdProps
  } = (0, _testidGenerator.default)();
  if (!isAvailable) {
    return null;
  }
  const regexPattern = validation?.regularExpression ? new RegExp(validation.regularExpression) : undefined;
  const availableOptions = selectField.availableOptions?.map(opt => ({
    label: opt,
    value: opt
  }));
  const currentOptions = Array.isArray(availableOptions) && !options ? availableOptions : options ?? [];
  const isOneCountry = name === _constants.NAMES.COUNTRY && currentOptions.length === 1;
  const renderSelectOption = (item, index) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.MenuItem, {
    value: item.value,
    ...getTestIdProps(`${name}-select-field-option`),
    children: labelMapper ? labelMapper.getLocalizationKey(item.label) : item.label
  }, index);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Grid, {
    size: {
      xs: 12,
      sm: 12
    },
    style: {
      order: displayOrder
    },
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Box, {
      mb: 4,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactHookForm.Controller, {
        name: name,
        rules: {
          required: validation?.isMandatory,
          maxLength: validation?.maxLength,
          minLength: validation?.minLength,
          pattern: regexPattern
        },
        defaultValue: initialValue,
        render: ({
          field,
          fieldState
        }) => /*#__PURE__*/(0, _jsxRuntime.jsxs)(_mui.FormControl, {
          fullWidth: true,
          sx: {
            marginBottom: 0
          },
          required: validation?.isMandatory,
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.InputLabel, {
            id: `${name}-label`,
            children: label
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(SelectWrapper, {
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Select, {
              ...field,
              fullWidth: true,
              variant: "outlined",
              value: isOneCountry ? String(currentOptions[0]?.value) : field.value,
              labelId: `${name}-label`,
              label: label,
              error: !!fieldState.error,
              required: validation?.isMandatory,
              disabled: isDisabled,
              inputProps: {
                'data-testid': getTestId(`${name}-select-field`)
              },
              children: currentOptions.map(renderSelectOption)
            })
          }), fieldState.error ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.FormHelperText, {
            error: true,
            children: (0, _utils.renderValidationMessage)(fieldState.error, validation)
          }) : null]
        })
      })
    })
  });
};
exports.SelectFormFieldByConfig = SelectFormFieldByConfig;
//# sourceMappingURL=SelectFormFieldByConfig.js.map